import React, { Component } from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import BannerImg from "../../assets/images/banner/partner.png";
import { Helmet } from "react-helmet";

class Benefits extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Benefits of Enterprise Collaboration | Avani Cimcon</title>
          <meta
            name="keywords"
            content="Partner Program, Partner Program Benefits, partner program, Attractive Margins, Extensive Sales and Marketing Support, In-Depth Training, Other benefits"
          />
          <meta
            name="description"
            content="Benefits of Enterprise Collaboration explains how Avani Cimcon works with partners through interoperability, implementation capability, enterprise delivery, and technology integration."
          />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Benefits of Enterprise Collaboration</h1>
            <h5>Implementation capability, interoperability and delivery support</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <h2 className="text-primary">Enterprise collaboration benefits</h2>
              <p>
                This page explains the value of partner ecosystems in enterprise software delivery.
                The emphasis is on implementation capability, interoperability, shared delivery,
                and practical technology integration.
              </p>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Benefits of enterprise collaboration include:</h5>
                <ul>
                  <li className="mb-3">
                    <b className="text-primary">Implementation capability:</b>
                    <p>
                      Partners can extend delivery capacity and participate in more complete
                      implementation programs.
                    </p>
                  </li>
                  <li className="mb-3">
                    <b className="text-primary">Interoperability:</b>
                    <p>
                      The ecosystem works best when different systems, products and services fit
                      together cleanly.
                    </p>
                  </li>
                  <li className="mb-3">
                    <b className="text-primary">Enterprise delivery:</b>
                    <p>
                      Joint delivery helps enterprises move from planning into real execution.
                    </p>
                  </li>
                  <li>
                    <b className="text-primary">Technology integration:</b>
                    <p>
                      Integration support matters when software, infrastructure and operations must
                      work together.
                    </p>
                  </li>
                </ul>
              </div>

              <h5 className="text-primary mt-4 mb-3">
                Partner ecosystems can also support:
              </h5>
              <div className="shadow-sm p-4 mt-2">
                <ul>
                  <li className="mb-3">End-to-end solutions for enterprise customers</li>
                  <li className="mb-3">Local support through regional partners</li>
                  <li className="mb-3">Implementation of projects from business partners</li>
                  <li className="mb-3">Joint bidding and delivery for enterprise programs</li>
                  <li className="mb-3">Post-sales support of partner solutions and products</li>
                  <li className="mb-3">Product enhancement for existing customer environments</li>
                  <li>Remote delivery and technology support</li>
                </ul>
              </div>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Where this connects</h5>
                <p className="mb-0">
                  The collaboration model connects naturally to{" "}
                  <Link to="/objective">Enterprise Collaboration</Link>,{" "}
                  <Link to="/partners-program">Enterprise Delivery Ecosystem</Link>, and{" "}
                  <Link to="/it-consulting-services">IT Consulting Services</Link>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Benefits;
